export const formatTimestampForDisplay = (
    timestamp: string | null | undefined
): string | null => {
    if (!timestamp) {
        return null;
    }

    const parsedDate = new Date(timestamp);
    if (isNaN(parsedDate.getTime())) {
        return null;
    }

    return parsedDate.toLocaleString();
};
